import { render, staticRenderFns } from "./policyHolderForm.vue?vue&type=template&id=d08634ee&scoped=true&"
import script from "./policyHolderForm.vue?vue&type=script&lang=js&"
export * from "./policyHolderForm.vue?vue&type=script&lang=js&"
import style0 from "./policyHolderForm.vue?vue&type=style&index=0&id=d08634ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08634ee",
  null
  
)

export default component.exports